const Worms = (props) => {
    return (
        <div className="lyrics eggshell">
            <h2>Worms – a brief monodrama</h2>
            <h4>Heather Green</h4>
            <p>It's like the doctor coming over<br/>
            To give you an extra toe.<br/>
            You've told him you don't want six toes<br/>
            And are really quite happy with five.<br/>
            Nevertheless, he insists, <br/>
            Saying it's good for you<br/>
            And won't cost a thing,<br/>
            But time.<br/>
            <br/>
            And you start to think <br/>
            about the steps you've  taken, and how you've run too often,<br/>
            and too long, and that:<br/>
            "One day, I'll be dead. <br/>
            And the worms will eat my body.<br/>
            And who am I to deny them an extra meal?"<br/>
            <br/>
            And so you acquiesce <br/>
            And now you have eleven toes<br/>
            Five on your right foot<br/>
            Six on your left<br/>
            And even your best stride has a limp.<br/>
            The doctor says:<br/>
            "It's barely perceptible."<br/>
            But you know that people notice.<br/>
            Friends start to treat you differently,<br/>
            As you're walking with your face <br/>
            turned downward,<br/>
            Eyes always fixed on that lump,<br/>
            The one you didn't want <br/>
            The one that makes you stumble<br/>
            And you fall and then your face is in the mud with people laughing all around you:<br/>
            Ha ha hahaha haha ha!<br/>
            "I hate worms."<br/>
            </p>
        </div>
    )
}
export default Worms